import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";

interface BannerTutorialProps {
    banner: any,
    title: String,
    subTitle: String,
    titleColor: any,
    subTitleColor:any
    trialEligible: boolean
    
}

const BannerTutorial: React.FC<BannerTutorialProps> = ({ banner, title, subTitle, titleColor, subTitleColor, trialEligible }) => {
  return (
      <React.Fragment>
          <section className="subscription-hero" style={{ backgroundImage: `linear-gradient(100deg, rgba(15, 32, 67, .96), rgba(31, 87, 214, .78)), url(${banner})` }}>
            <div className="subscription-hero__copy">
              <span className="subscription-eyebrow"><Sparkles size={15} /> Contract Builder Pro</span>
              <p className="subscription-hero__kicker">{title}</p>
              <h1>{subTitle}</h1>
              <p className="subscription-hero__description">Create, send, sign, and manage professional contracts from one secure workspace.</p>
              <div className="subscription-hero__benefits">
                {trialEligible ? <span><CheckCircle2 size={17} /> 30 days free</span> : null}
                <span><CheckCircle2 size={17} /> No setup fee</span>
                <span><CheckCircle2 size={17} /> Cancel anytime</span>
              </div>
            </div>
          </section>
       
    </React.Fragment>
  );
};

export default BannerTutorial;
